import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import '@progress/kendo-angular-intl/locales/de/all';
import { CommonModule } from '@angular/common';
import { HomeViewComponent } from './home-view/home-view.component';
import { ScannerComponent } from './scanner/scanner.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    HomeViewComponent,
    ScannerComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductSearchModule { }
